import { hydratePieceCountForExistingLine } from './pieceCount';
import {
  normalizeProductIdentity,
  normalizeSelectedOptionIdentity,
  resolveLineId
} from './lineIdentity';
import { recalculateOrderProductsWithLineIds } from './recalculateOrderProducts';

type HydrationLine = Record<string, any>;

type HydrationPricingContext = {
  discountCodeObj: unknown;
  storeDiscounts: unknown[];
  customerInfo: unknown;
};

export const hydrateOrderLineForForm = (line: HydrationLine): HydrationLine => {
  const lineId = resolveLineId(line);
  const productId = normalizeProductIdentity(line);
  const selectedOptionId = normalizeSelectedOptionIdentity(line);
  const quantity = Number(line.quantity ?? line.qty ?? 0);

  return hydratePieceCountForExistingLine({
    ...line,
    lineId,
    orderProductLineID: lineId,
    productId,
    _id: productId,
    qty: quantity,
    quantity,
    selectedOptionId,
    selectedOption: line.selectedOption || null
  });
};

export const hydrateOperationalReturnOrderForForm = <
  T extends {
    products?: HydrationLine[];
    buyAndGetProducts?: HydrationLine[];
    express?: boolean;
    orderType?: 'standard' | 'return';
    returnItemsChargeMode?: 'no_charge' | 'charge';
  }
>(
  order: T,
  pricingContext?: HydrationPricingContext
): T & { products: HydrationLine[]; buyAndGetProducts: HydrationLine[] } => {
  const hydratedOrder = {
    ...order,
    products: (order.products ?? []).map(hydrateOrderLineForForm),
    buyAndGetProducts: (order.buyAndGetProducts ?? []).map(hydrateOrderLineForForm)
  };

  if (order.orderType !== 'return' || !pricingContext) return hydratedOrder;

  const { newOrderProds, buyAndGetProds } = recalculateOrderProductsWithLineIds({
    discountCodeObj: pricingContext.discountCodeObj,
    products: hydratedOrder.products,
    express: Boolean(order.express),
    storeDiscounts: pricingContext.storeDiscounts,
    customerInfo: pricingContext.customerInfo,
    previousBuyAndGetProducts: hydratedOrder.buyAndGetProducts,
    orderType: order.orderType,
    returnItemsChargeMode: order.returnItemsChargeMode
  });

  return {
    ...hydratedOrder,
    products: newOrderProds,
    buyAndGetProducts: buyAndGetProds
  };
};
